var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"height":"25","viewBox":"0 0 10 20","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"5","cy":"5","r":"4","stroke":_vm.strokeColor('M'),"fill":_vm.fillColor('M')}}),_c('circle',{attrs:{"cx":"5","cy":"15","r":"4","stroke":_vm.strokeColor('W'),"fill":_vm.fillColor('W')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }